import React from 'react';
import {
  Button,
  Form,
  DatePicker,
  Radio,
  Select,
  Spin,
  Table,
  Row,
  Col,
} from 'antd';
import moment from 'moment'
import {
  DmsTab,
} from '../../components';
import  * as echarts from 'echarts';
import {
  dmsPurchaseList,
  purchasingReport,
} from '../../service/reportForm';
import { fetchChannelList } from '../../service/home';

const FormItem = Form.Item;
const RadioButton = Radio.Button;
const RadioGroup = Radio.Group;
const RangePicker = DatePicker.RangePicker;
const labelOption = {
  show: true,
  position: 'top',
  distance: 15,
  align: 'center',
  verticalAlign: 'middle',
  // rotate: 90,
  // formatter: '{c}  {name|{a}}',
  formatter: '{c}',
  fontSize: 16,
  /*rich: {
    name: {
      textBorderColor: '#fff',
    },
  },*/
};

class CustomerInvoice extends React.Component {
  constructor(props) {
    super(props);
    this.channelId = window.sessionStorage.getItem('cur_channelId');
    let start = new Date();
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    start.setMilliseconds(0);
    let end = new Date(start.getTime());
    end.setDate(end.getDate() + 1);
    end = new Date(end.getTime() - 1);
    this.state = {
      channelCode: this.channelId,
      searchObj: {
        'channelCode': 'ALL', //渠道编码默认ALL，如WJH，HY数据取自/xweb/api/v1/dms/homePage/channel接口（必填）
        //type和（startDate、endDate）二选一必填
        'type': '1', //日期筛选类型（1：今日；2：周；3：月；4：季度；5：年）
        'startDate': moment(start), //查询开始时间
        'endDate': moment(end),  //查询结束时间
        'salesUnitId': '',  //购货单位
      },
      data: {},
      list: [],
      buy_org: [],
      qykhzb: {},
      loading: false,
    };
    this.initData = this.initData.bind(this);
    this.advanceReset = this.advanceReset.bind(this);
    this.advanceSubmit = this.advanceSubmit.bind(this);
    this.renderChart1 = this.renderChart1.bind(this);
    this.renderChart2 = this.renderChart2.bind(this);
  }

  advanceReset(e) {
    e.preventDefault();
    let self = this;
    let start = new Date();
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    start.setMilliseconds(0);
    let end = new Date(start.getTime());
    end.setDate(end.getDate() + 1);
    end = new Date(end.getTime() - 1);
    self.setState({
      searchObj: {
        'channelCode': 'ALL', //渠道编码默认ALL，如WJH，HY数据取自/xweb/api/v1/dms/homePage/channel接口（必填）
        //type和（startDate、endDate）二选一必填
        'type': '1', //日期筛选类型（1：今日；2：周；3：月；4：季度；5：年）
        'startDate': moment(start), //查询开始时间
        'endDate': moment(end),  //查询结束时间
        'salesUnitId': '',  //购货单位
      },
    }, function () {
      self.props.form.resetFields();
      self.initData();
    });
  };

  advanceSubmit(e) {
    e.preventDefault();
    /* 筛选确认 */
    let self = this;
    let values = this.props.form.getFieldsValue();
    values.startDate = values.Date && values.Date[0] && values.Date[0] ? values.Date[0] : '';
    values.endDate = values.Date && values.Date[1] && values.Date[1] ? values.Date[1] : '';
    delete values.Date;
    this.setState({
      searchObj: {
        ...this.state.searchObj,
        ...values,
      },
    }, function () {
      self.initData();
    });
  };

  initData() {
    let searchObj = {...this.state.searchObj};
    searchObj.startDate = searchObj.startDate && searchObj.startDate._isAMomentObject ? searchObj.startDate.format('YYYY-MM-DD') : '';
    searchObj.endDate = searchObj.endDate && searchObj.endDate._isAMomentObject ? searchObj.endDate.format('YYYY-MM-DD') : '';
    if(!!searchObj.type) {
      delete searchObj.endDate;
      delete searchObj.startDate;
    }
    this.setState({ loading: true });
    purchasingReport(searchObj).then((result) => {
      if (result.status) {
        /*
         {  //左上图数据
         "unShipAmt": { //未发运
         "amount": 55298623.81, //数量
         "tb": "+100.0%" //同比
         },
         "orderAmt": {//开单
         "amount": 26002207.78,
         "tb": "-49.0%"
         },
         "returnAmt": {//退货
         "amount": 0,
         "tb": "+0%"
         },
         "shipAmt": { //发运含退货
         "amount": 22241910.08,
         "tb": "-65.0%"
         }
         },
        * */
        let totalMap = [
          {key: 'orderAmt', name: '开单'},
          {key: 'shipAmt', name: '发运含退货'},
          {key: 'returnAmt', name: '退货'},
          {key: 'unShipAmt', name: '未发运'}
          ]
        let total = result.data.total || {};
        this.renderChart1(totalMap.map(x => ({name: x.name, value: total[x.key].amount, tb: total[x.key].tb})));
        this.renderChart2(result.data.qykhzb || {});
        const getTb = (tb) => {
          if (/^(-|\+)?0%$/.test(tb)) {
            return '-'
          }
          return tb
        }
        this.setState({
          list: (result.data.channelTotal || []).map(x => ({
            ...x,
            orderAmtTb: getTb(x.orderAmtTb),
            shipAmtTb: getTb(x.shipAmtTb),
          })),
          qykhzb: result.data.qykhzb,
          loading: false,
        });
      } else {
      }
    });
  }

  componentDidMount() {
    let self = this;
    this.initData();
    /*渠道类型*/
    fetchChannelList().then(res => { //渠道
      if (res.status) {
        let arr = [];
        res.data.forEach(x => {
          arr.push({
            text: x.name,
            value: x.code,
          });
        });
        self.setState({ channel_type: arr },
        );
      }
    });

    dmsPurchaseList({channelCode: this.state.channelCode, p: 1, s: 100}).then(res => { //购货单位
      if (res.status) {
        let arr = [
          {
            text: '全部',
            value: ''
          }
        ];
        for (let i = 0; i < res.data.length; i++) {
          let x = res.data[i];
          arr.push({
            text: x.name,
            value: `${x.id}`
          })
        }
        self.setState({buy_org: arr})
      }
    });
  }

  renderChart1(list) {
    const chart1 = echarts.init(document.getElementById('chart1'));
    chart1.clear();
    chart1.setOption({
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
      },
      grid: [
        {
          top: 50,
          left: 100,
          right: 50,
          height: '75%',
        },
      ],
      xAxis: {
        type: 'category',
        axisTick: { show: false },
        // data: ['期末欠款', '逾期金额'],
        data: list.map(x => x.name),
        axisLabel: {
          formatter: function (name, index) {
            let arr = [];
            let tb = list[index].tb;
            arr.push(name)
            if (/^(-|\+)?0%$/.test(tb)) {
              arr.push(`{b|-}`)
            }else if (/^(\+)?\d+(\.\d+)?%/.test(tb)) {
              arr.push(`{red|${tb}}`)
            }else if (/^-\d+(\.\d+)?%/.test(tb)) {
              arr.push(`{green|${tb}}`)
            }
            return arr.join('\n')
           },
          rich: {
            a: {
              align: 'left',
              padding: [30, 0, 0, 0]
            },
            b: {
              color: '#666666',
              padding: [15, 0, 0, 0]
            },
            green: {
              color: '#7dbb00',
              padding: [15, 0, 0, 0]
            },
            red: {
              color: '#d61518',
              padding: [15, 0, 0, 0]
            }
          }
        }
      },
      yAxis: {
        type: 'value',
        // name: '单位：万元',
        minInterval: 1,
        axisLabel: {
          formatter: function (value, index) {
            if (index === 0 && value === 0) {
              return `{b|${value}}{a|同比}`
            }
            return value
          },
          rich: {
            a: {
              align: 'right',
              padding: [80, 0, 0, 0]
            },
            b: {
              align: 'right',
              padding: [0, 0, 0, 80]
            },
          }
        }
      },
      series: [
        {
          type: 'bar',
          label: labelOption,
          barWidth: '40%',
          data: list.map(x => x.value),
          itemStyle: {
            normal: {
              //这里是重点
              color: function (params) {
                //注意，如果颜色太少的话，后面颜色不会自动循环，最好多定义几个颜色
                /*var colorList = [
                  '#9d5ae5', '#5a95db', '#7dbb00', '#ffbb00', '#f75314',
                  '#b00454', '#00a1f1', '#02c1a5', '#efee18', '#dd0527',
                ];*/
                var colorMap = {
                  '开单': '#02c1a5',
                  '发运含退货': '#ffbb00',
                  '退货': '#f75314',
                  '未发运': '#666666',
                }
                return colorMap[params.name];
              },
            },
          },
        },
      ],
    });
  }

  renderChart2(data) {
    const chart2 = echarts.init(document.getElementById('chart2'));
    chart2.clear();
    chart2.setOption({
      tooltip: {
        trigger: 'item',
        // formatter: '{a} <br/>{b}: {c} ({d}%)'
        formatter: '{b}: {c} ({d}%)'
      },
      series: [
        {
          type: 'pie',
          radius: ['40%', '55%'],
          label: {
            show: true,
            formatter: '{d}%',
          },
          data: [
            {
              value: data.indicatorGap || 0,
              name: '指标缺口',
              itemStyle: {
                color: '#d61518'
              }
            },
            {
              value: data.amountCompleted || 0,
              name: '完成额',
              itemStyle: {
                color: '#02c1a5',
              }
            }
          ]
        }
      ]
    });
  }
  setDateValue = (type) => {
    // 1：今日；2：周；3：月；4：季度；5：年
    // 选择‘今日’，时间为今天到今天，2021-02-05 00:00 到 2021-02-05 23:59
    // 选择‘周’，时间为本周一到今天，2021-02-01 00:00 到 2021-02-05 23:59
    // 选择‘季度’时间为本季度1号到今天，2021-01-01 00:00 到 2021-02-05 23:59
    // 选择‘年’时间为今年1号到今天，2021-01-01 00:00 到 2021-02-05 23:59
    let start = new Date();
    start.setHours(0);
    start.setMinutes(0);
    start.setSeconds(0);
    start.setMilliseconds(0);
    let end = new Date(start.getTime());
    end.setDate(end.getDate() + 1);
    end = new Date(end.getTime() - 1);
    switch(type){
      case '1':
        break;
      case '2':
        let dayIndex = start.getDay();
        let diff = dayIndex === 0 ? -6 : 1 - dayIndex;
        let d = new Date(start.getTime());
        d.setDate(d.getDate() + diff);
        start = d;
        break;
      case '3':
        start.setDate(1);
        break;
      case '4':
        let month = start.getMonth();
        if(0<=month && month <= 2) {
          start.setMonth(0);
          start.setDate(1);
        }
        if(3<=month && month <= 5) {
          start.setMonth(3);
          start.setDate(1);
        }
        if(6<=month && month <= 8) {
          start.setMonth(6);
          start.setDate(1);
        }
        if(9<=month && month <= 11) {
          start.setMonth(9);
          start.setDate(1);
        }
        break;
      case '5':
        start.setMonth(0);
        start.setDate(1);
        break;
      default:
        break;
    }
    this.props.form.setFieldsValue({ Date: [moment(start), moment(end)] });
  }
  render() {
    const { searchObj, channel_type, loading, list, qykhzb, buy_org } = this.state;
    const { getFieldDecorator, setFieldsValue } = this.props.form;
    const tableProps = {
      rowKey: 'code',
      dataSource: list || [],
      columns: [
        {
          title: '渠道',
          dataIndex: 'name',
        },
        {
          title: '开单',
          dataIndex: 'orderAmt',
        },
        {
          title: '开单同比',
          dataIndex: 'orderAmtTb',
          render: (text) => {
            if(text === '-') {
              return <span style={{color: '#666'}}>-</span>
            } else {
              return /^-/.test(text) ? <span style={{color: '#7dbb00'}}>{text}</span> : <span style={{color: '#d61518'}}>{text}</span>
            }
          }
        },
        {
          title: '发运',
          dataIndex: 'shipAmt',
        },
        {
          title: '发运同比',
          dataIndex: 'shipAmtTb',
          render: (text) => {
            if(text === '-') {
              return <span style={{color: '#666'}}>-</span>
            } else {
              return /^-/.test(text) ? <span style={{color: '#7dbb00'}}>{text}</span> : <span style={{color: '#d61518'}}>{text}</span>
            }
          }
        },
        {
          title: '未发运',
          dataIndex: 'unShipAmt',
        },
      ]
    }
    return <Spin spinning={loading}>
      <div style={{ background: '#fff' }}>
        <DmsTab options={['采购报表']} defaultKey={0} />
        <div className="advanceForm-box">
          <div className="advanceForm-content">
            <Form layout="inline" onSubmit={this.advanceSubmit}>
              <FormItem label="日期筛查">
                {
                  getFieldDecorator('type', {
                    initialValue: searchObj.type,
                    getValueFromEvent: (e) => {
                      // setFieldsValue({ Date: [] });
                      this.setDateValue(e.target.value);
                      return e.target.value;
                    },
                  })(<RadioGroup>
                    {/*1：今日；2：周；3：月；4：季度；5：年*/}
                    <RadioButton value="1">今日</RadioButton>
                    <RadioButton value="2">周</RadioButton>
                    <RadioButton value="3">月</RadioButton>
                    <RadioButton value="4">季度</RadioButton>
                    <RadioButton value="5">年</RadioButton>
                  </RadioGroup>)
                }
              </FormItem>
              <FormItem label={null} colon={false}>
                {
                  getFieldDecorator('Date', {
                    initialValue: !!searchObj.startDate && !!searchObj.endDate ? [
                      searchObj.startDate,
                      searchObj.endDate,
                    ] : undefined,
                    getValueFromEvent: (e) => {
                      setFieldsValue({ type: '' });
                      return e;
                    },
                  })(<RangePicker format="YYYY-MM-DD" locale={{lang: {locale: 'zh-CN'}}} />)
                }
              </FormItem>
              <FormItem label='渠道'>
                {
                  getFieldDecorator('channelCode', {
                    initialValue: searchObj.channelCode,
                  })(<Select style={{ width: 200 }}>{
                    (channel_type || []).map(x => <Select.Option key={x.value}>{x.text}</Select.Option>)
                  }</Select>)
                }
              </FormItem>
              <FormItem label='购货单位'>
                {
                  getFieldDecorator('salesUnitId', {
                    initialValue: searchObj.salesUnitId,
                  })(<Select style={{ width: 200 }}>{
                    (buy_org || []).map((x, index) => <Select.Option key={index} value={x.value}>{x.text}</Select.Option>)
                  }</Select>)
                }
              </FormItem>
              <FormItem>
                &emsp;&emsp;
                <Button onClick={this.advanceReset}>
                  重置
                </Button>
                &emsp;&emsp;
                <Button
                  type="primary"
                  htmlType="submit"
                >
                  筛选
                </Button>
              </FormItem>
            </Form>
          </div>
        </div>
        <div className="dms-split-bar" />
        <div className="dms-table-box">
          <Row gutter={16}>
            <div className="dms-box-head">采购情况</div>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <div className="dms-table-box"
                   id="chart1"
                   style={{ width: '100%', height: 645, overflow: 'hidden' }}></div>
            </Col>
            <Col span={12}>
              <div className="dms-table-box">
                <Table {...tableProps} />
              </div>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              <div className="dms-box-head">签约客户指标完成情况</div>
              <Row>
                <Col span={11}>
                  <div className="dms-table-box"
                       id="chart2"
                       style={{ width: '100%', height: 400, overflow: 'hidden' }}></div>
                </Col>
                <Col span={13}>
                  <Row type="flex" justify="center" align="middle" style={{padding: '30% 10px', height: 400,}} >
                    <Col span={12}><span style={{color: '#d61518'}}>●</span>&emsp;指标缺口：{qykhzb.indicatorGap}</Col>
                    <Col span={12}>签约指标：{qykhzb.signingIndex}</Col>
                    <Col span={12}><span style={{color: '#02c1a5'}}>●</span>&emsp;完成额：{qykhzb.amountCompleted}</Col>
                    <Col span={12}>完成率：{qykhzb.completionRate}</Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
      </div>
    </Spin>;
  }
}
;
export default Form.create()(CustomerInvoice);



// WEBPACK FOOTER //
// ./src/routes/reportForm/PurchaseChart.js